
import superagent from "superagent";
import {deep_copy} from "../../../lib/js-utils";
import {authorize, authorize_onboarding} from "../../helper/authorize-token";
import {process_pay_frequency} from "../../../lib/time/pay_frequency";

const CD_SET_LOADING = "CD_SET_LOADING";
const SET_OFFERINGS = "SET_OFFERINGS";

const setOfferings = (offerings) => {
  return dispatch => {
    dispatch({
      type: SET_OFFERINGS,
      payload: offerings,
    })
  }
}

const loadAllOfferings = (offering_ids) => {
  return new Promise(resolve => {
    return superagent.agent()
      .post("/api/security/load-offerings")
      .send({ offering_ids })
      .then(res => {
        return resolve(res.body);
      })
  })
}

const purchaseNoLoginRequest = (wlf_id, last_name, firm_name, amt_usd, cusip) => {
  return new Promise(resolve => {
    return superagent.agent()
      .post("/api/security/purchase-no-login")
      .send({ wlf_id, last_name, firm_name, amt_usd, cusip})
      .then(res => {
        return resolve(res.body);
      })
  })
}

const purchaseRequest = (token, cusip, amt_usd, acct_index) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/security/purchase")
      .use(authorize(token))
      .send({ cusip, amt_usd, acct_index })
      .then(res => {
        if (res.body.ok) {
          return resolve(res.body.data);
        }
        reject(res.body.error);
      })
  })
}

const cancelRequest = (
  token, onboarding_token, ticket_id, send_email, reply_text) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/security/cancel")
      .use(authorize_onboarding(token, onboarding_token))
      .send({ ticket_id, send_email, reply_text })
      .then(res => {
        if (res.body.ok) {
          return resolve(res.body.data);
        }
        reject(res.body.error);
      })
  })
}

const fillRequest = (
  token, ticket_id, reply_text, fill_px_usd) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/security/fill")
      .use(authorize(token))
      .send({ticket_id, reply_text, fill_px_usd })
      .then(res => {
        if (res.body.ok) {
          return resolve(res.body.data);
        }
        return reject(res.body);
      })
  })
}

const PendingFundsRequest = (token, ticket_id) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/security/pending-funds")
      .use(authorize(token))
      .send({ ticket_id })
      .then(res => {
        if (res.body.ok) {
          return resolve(res.body.data);
        }
        return reject(res.body);
      })
  })
}

const DEFAULT_STATE = {
  tables: {},
  loading: false,
}

const create_index = table => {
  const index = [];

  table.items.forEach(item => {
    const values = Object.values(item).map(val => val.toString().toLowerCase());
    if ("Pay Frequency" in item) {
      values.push(process_pay_frequency(item["Pay Frequency"]).toLowerCase());
    }
    index.push(values.join(" "));
  })
  table.index = index;
  return table;
}

const CDOfferingReducer = (state = DEFAULT_STATE, action) => {

  const new_state = deep_copy(state);

  switch(action.type) {
    case CD_SET_LOADING:
      new_state.loading = action.loading;
      return new_state;

    case SET_OFFERINGS:
      Object.keys(action.payload).forEach(table_name => {
        new_state.tables[table_name] = create_index(action.payload[table_name]);
      })
      return new_state;
    default:
      return state;
  }
}

export {
  CDOfferingReducer, purchaseRequest, cancelRequest,
  fillRequest, loadAllOfferings, setOfferings, purchaseNoLoginRequest,
  PendingFundsRequest };
